import React from "react";

import FallbackImage from "components/global/FallbackImage";
import type { ImageVariant } from "../../utils/media";

import {
  IdentityCellCopy,
  IdentityCellImageSlot,
  IdentityCellSubtitle,
  IdentityCellTitle,
  IdentityCellWrap,
} from "./styles/entity-identity-cell.styles";

type EntityIdentityCellProps = {
  imageAlt: string;
  imageSrc?: string | null;
  fallbackLabel?: string;
  primaryText: React.ReactNode;
  secondaryText?: React.ReactNode;
  variant?: ImageVariant;
  size?: "sm" | "md";
};

export const EntityIdentityCell: React.FC<EntityIdentityCellProps> = ({
  fallbackLabel,
  imageAlt,
  imageSrc,
  primaryText,
  secondaryText,
  size = "md",
  variant = "generic",
}) => (
  <IdentityCellWrap>
    <IdentityCellImageSlot $size={size}>
      <FallbackImage
        alt={imageAlt}
        className={size === "sm" ? "h-10 w-10 rounded-2xl" : "h-12 w-12 rounded-2xl"}
        fallbackLabel={fallbackLabel}
        src={imageSrc}
        variant={variant}
      />
    </IdentityCellImageSlot>
    <IdentityCellCopy>
      <IdentityCellTitle>{primaryText}</IdentityCellTitle>
      {secondaryText ? <IdentityCellSubtitle>{secondaryText}</IdentityCellSubtitle> : null}
    </IdentityCellCopy>
  </IdentityCellWrap>
);
